export class RemoteInfoChargeRecord {
    chargeRecordId: string;

    constructor(chargeRecordId: string) {
        this.chargeRecordId = chargeRecordId;
    }
}

export class RemoteInfoMedia {
    stationRef: string;
    chargePointRef: string;
    plugRef: string;
    mediaCode: string;
    chargeAreaRef: string;

    constructor(stationRef: string, chargePointRef: string, plugRef: string, mediaCode: string) {
        this.stationRef = stationRef;
        this.chargePointRef = chargePointRef;
        this.plugRef = plugRef;
        this.mediaCode = mediaCode;
    }
}
